import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    teachers: [],
  },
  mutations: {
    SET_TEACHERS(state: any, teachers: any) {
      state.teachers = teachers.map((teacher: any) => {
        let teachersBoards = teacher.boardsTeachersByTeacherId;
        if (teachersBoards && teachersBoards.nodes.length > 0) {
          teacher.boards = teachersBoards.nodes.map((teacher: any) => ({
            ...teacher.boardByBoardId,
            boardsTeacherId: teacher.id,
          }));
        }
        return teacher;
      });
    },
  },
  actions: {
    async PULL_TEACHERS({ commit }: any) {
      let response = await query(`query getAllTeachersDexAdmin{
        allTeachers(orderBy: NAME_ASC) {
          nodes {
            id
            name
            avatarUrl
            boardsTeachersByTeacherId{
              nodes {
                id
                boardByBoardId {
                  id
                  title
                }
              }
            }
          }
        }
      }`);
      let teachersNodes = response.data.allTeachers;
      if (teachersNodes) {
        commit('SET_TEACHERS', teachersNodes.nodes);
      }
    },

    async PUSH_TEACHER({ commit, rootState }: any, teacher: any) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      const { name, avatarUrl } = teacher;
      let response;
      let teacherResponse;
      if (teacher.id != null) {
        response = await mutation(
          `mutation updateTeacher ($teacherId: Int!, $name: String!, $avatarUrl: String!) {
              updateTeacherById(
                input: {
                  id: $teacherId,
                  teacherPatch:{
                    name: $name,
                    avatarUrl: $avatarUrl
                  }
                }
              ){
                teacher {
                  id
                  name
                  avatarUrl
                  boardsTeachersByTeacherId{
                    nodes {
                      id
                      boardByBoardId {
                        id
                        title
                      }
                    }
                  }
                }
              }
            }`,
          {
            teacherId: teacher.id,
            name,
            avatarUrl,
          },
        );
        teacherResponse = response.data.updateTeacherById.teacher;
      } else {
        response = await mutation(
          `mutation createTeacher ($userId: Int!, $name: String!, $avatarUrl: String!) {
              createTeacher(
                input: {
                  teacher: {
                    userId: $userId,
                    name: $name,
                    avatarUrl: $avatarUrl
                  }
                }
              ) {
                teacher {
                  id
                  name
                  avatarUrl
                  boardsTeachersByTeacherId{
                    nodes {
                      id
                      boardByBoardId {
                        id
                        title
                      }
                    }
                  }
                }
              }
            }`,
          {
            userId: userId,
            name,
            avatarUrl,
          },
        );
        teacherResponse = response.data.createTeacher.teacher;
      }

      if (teacherResponse != null) {
        commit('SET_TEACHERS', [
          ...rootState.teachers.teachers,
          teacherResponse,
        ]);
      }
    },

    async ADD_BOARDS_TEACHER(_: any, data: any) {
      let teacherId = data.teacherId;
      let boardId = data.boardId;

      await mutation(
        `mutation createBoardsTeacher($teacherId: Int!, $boardId: Int!){
          createBoardsTeacher(
            input: {
              boardsTeacher: {
                teacherId: $teacherId,
                boardId: $boardId
              }
            }
          ) {
            boardsTeacher {
              teacherId
            }
          }
        }`,
        {
          teacherId: +teacherId,
          boardId: boardId,
        },
      );
    },

    async REMOVE_BOARDS_TEACHER(_: any, boardsTeacherId: number) {
      await mutation(
        `mutation deleteBoardsTeachers($boardsTeacherId: Int!){
          deleteBoardsTeacherById(input: {
            id: $boardsTeacherId
          }) {
            boardsTeacher {
              id
            }
          }
        }`,
        {
          boardsTeacherId: boardsTeacherId,
        },
      );
    },
  },
};
